import React from "react"
import clsx from "clsx"
import UploadGroupBuilder from "../../UploadGroupBuilder/UploadGroupBuilder"
import ErrorHelper from "../../Errors/ErrorHelper"

class RoomTypeBuilderImageGroup extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'images',
      'tab-pane': true
    })
    return (
      <div className={tabClasses} id="images">
        {ErrorHelper.renderErrors(this.props.errors, ['images', 'image_description'])}
        <UploadGroupBuilder
          upload_type="image"
          upload_type_plural="images"
          upload_groups={this.props.image_group ? [this.props.image_group] : [{ images: [] }]}
          onChange={this.props.onImageChange}
          data_table_path={this.props.images_data_table_path}
          multiple={true} 
          read_only={this.props.read_only}
          helperText={"room_type_images_helper_tex"}
          onChangeOrder={this.props.onChangeOrder}
          image_types={this.props.image_types}
          displayImageTypes={true}
          onChangeImageType={this.props.onChangeImageType}
          filterSize={true}
          />
      </div>
    )
  }
}

export default RoomTypeBuilderImageGroup
